import { ErrorHandler, Injectable, inject } from '@angular/core';
import { APP_CONFIG } from '@core/config/app-config.token';
import { NotificationService } from '@core/notifications/notification.service';

/** Last-resort handler for uncaught errors. Expected failures must be handled where they occur. */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly config = inject(APP_CONFIG);
  private readonly notifications = inject(NotificationService);

  handleError(error: unknown): void {
    if (this.config.enableDebugLogs) {
      console.error(error);
    }
    this.notifications.error('An unexpected error occurred.');
  }
}
